export interface UserEmailQueryParams {
  email: string;
  portalUrl: string;
  loginFlow: LoginFlow;
}

export enum LoginFlow {
  LOGIN = "login",
  FIRST_TIME_LOGIN = "first_time_login",
}

export interface userPoolResult {
  poolId: string;
  clientId: string;
  cognitoUser: string;
  portalId: string;
  userId: string;
}
